module.exports = __webpack_public_path__ + "376fb2f8e9637b88d0dfa361801a291a.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/avatars/AvatarChloe4.png
// module id = 147
// module chunks = 0